import React from "react";

export const Btn = ({ variant = "cyan", to, href, children, className = "", ...props }) => {
  const base =
    "inline-flex items-center justify-center gap-2 px-7 py-3.5 text-sm font-medium tracking-wide transition-all duration-300 cursor-pointer";
  const variants = {
    cyan: "bg-f2b-cyan text-f2b-black hover:shadow-[0_0_28px_rgba(0,190,255,0.5)] hover:-translate-y-0.5",
    outlineLight: "border border-white/30 text-white hover:border-f2b-cyan hover:text-f2b-cyan",
    outlineDark: "border border-f2b-filet text-f2b-black hover:border-f2b-cyan hover:text-f2b-cyan",
    dark: "bg-f2b-black text-white hover:bg-[#000] hover:-translate-y-0.5",
  };
  const cls = `${base} ${variants[variant]} ${className}`;
  if (href) return <a href={href} className={cls} {...props}>{children}</a>;
  return <button className={cls} {...props}>{children}</button>;
};

export default Btn;
